var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkulumlogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 49,
    viewBox: "0 0 269 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5089 46.8445C10.1012 46.8445 0 36.7432 0 24.2696C0 11.7961 10.1012 1.62891 22.5089 1.62891C34.9825 1.62891 45.0838 11.7961 45.0838 24.2696C45.0744 36.7432 34.9825 46.8445 22.5089 46.8445ZM22.9796 18.0281C19.8636 18.0281 18.1032 21.4172 18.1032 24.1943C18.1032 26.9715 19.8636 30.3605 22.9796 30.3605C26.1616 30.3605 27.8561 26.9715 27.8561 24.1943C27.8561 21.4172 26.1616 18.0281 22.9796 18.0281Z",
    fill: "#F99E1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6571 48.8776L65.3415 34.6342L65.4074 48.1904L48.7351 49L46.7676 0.950817L65.1343 0L65.2002 15.9285L75.5745 0.404803L90.8911 9.21633L77.6738 23.5915L90.8911 36.404L76.6571 48.8776Z",
    fill: "#F99E1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.851 28.4013C132.513 40.536 124.586 48.1237 112.376 48.1237C100.307 48.1237 93.2561 39.2463 92.4465 27.8553C91.9005 19.6557 91.6369 11.3148 91.2227 3.04933L107.49 2.64453C107.556 9.96864 107.697 17.2833 108.168 24.6075C108.3 27.3846 108.507 32.1293 112.442 32.1293C115.558 32.1293 115.699 28.4013 115.699 26.1608C115.699 18.4978 115.294 10.8441 115.021 3.18113H133.124C132.993 11.5879 133.059 19.9946 132.851 28.4013Z",
    fill: "#F99E1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.643 45.8923L137.322 47.2479L134.818 2.03234L152.037 1.48633L152.649 28.3257L169.999 26.2264L168.643 45.8923Z",
    fill: "#F99E1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.957 28.4013C211.618 40.536 203.682 48.1237 191.481 48.1237C179.413 48.1237 172.362 39.2463 171.552 27.8553C171.006 19.6557 170.742 11.3148 170.328 3.04933L186.596 2.64453C186.661 9.96864 186.803 17.2833 187.273 24.6075C187.405 27.3846 187.612 32.1293 191.547 32.1293C194.663 32.1293 194.805 28.4013 194.805 26.1608C194.805 18.4978 194.4 10.8441 194.127 3.18113H212.23C212.089 11.5879 212.155 19.9946 211.957 28.4013Z",
    fill: "#F99E1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.624 48.3329L246.798 24.6096L239.812 37.8269L233.646 25.7581L232.63 48.1258L213.246 46.6384L218.396 2.16652L235.746 2.57132L239.681 14.5742L244.557 3.72925L261.775 1.76172L268.083 46.4972L248.624 48.3329Z",
    fill: "#F99E1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkulumlogo2);
export default __webpack_public_path__ + "static/media/okulumlogo2.1ac3870993bdc9abe37d6a385436ab97.svg";
export { ForwardRef as ReactComponent };